
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth";

export default function ProtectedRoute({ children }) {
  const { user, subscription, loading, subscriptionLoading } = useAuth();

  if (loading || subscriptionLoading)
    return <div style={{ padding: 24 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!subscription?.account?.id)
    return <div>Access denied.</div>;
  if (subscription.account.verificationStatus === "pending")
    return <Navigate to="/verify-email" replace />;;


  return children;
}
